import { BaseDto } from '@/shared/dtos/base-dto';

export class dinamically_form extends BaseDto {
    public FormReadOnly !: boolean;
    public BotonGuardar !: boolean;
    public BotonCancelar !: boolean;
    public BotonClonar !: boolean;
    public AutoSaveData !: boolean;
    public nombre !: string;
    public descripcion !: string;
    public estado !: boolean;
    public api_call !: string;
 } 
